import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home'
import CompanyDynamics from '@/views/company_dynamics'
import About from '@/views/about'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    hidden: true
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    hidden: true
  }, {
    path: '/about',
    name: 'About',
    component: About,
    hidden: true
  }, {
    path: '/company-dynamics',
    name: 'CompanyDynamics',
    component: CompanyDynamics,
    hidden: true
  }, {
    path: '/dynamic-details',
    name: 'DynamicDetails',
    component: () => import( /* webpackChunkName: "searchpan" */ '../views/dynamic_details'),
    hidden: true
  }, {
    path: '/dynamic-details2',
    name: 'DynamicDetails2',
    component: () => import( /* webpackChunkName: "searchpan" */ '../views/dynamic_details2'),
    hidden: true
  }, {
    path: '/dynamic-details3',
    name: 'DynamicDetails3',
    component: () => import( /* webpackChunkName: "searchpan" */ '../views/dynamic_details3'),
    hidden: true
  }, {
    path: '/classic-case',
    name: 'classicCase',
    component: () => import( /* webpackChunkName: "searchpan" */ '../views/classic_case'),
    hidden: true
  }, {
    path: '/good-service',
    name: 'goodService',
    component: () => import( /* webpackChunkName: "searchpan" */ '../views/good_service'),
    hidden: true
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
